import { useEffect } from 'react';
import { localStorageService } from '@/helpers/storageHelpers';
import { COOKIES_CONSENT_EXPIRATION_DATE_STORAGE_KEY } from '@/bundle/CookiesBanner/cookiesContext';
import { isAfter, parseISO } from 'date-fns';

export const useCheckCookiesExpiration = (expiredCallback: () => void) => {
  const checkCookiesExpirationDate = () => {
    const cookiesConsentExpirationDate = localStorageService.get<string>(COOKIES_CONSENT_EXPIRATION_DATE_STORAGE_KEY);

    if (!cookiesConsentExpirationDate) return;

    const isCookiesConsentExpired = isAfter(new Date(), parseISO(cookiesConsentExpirationDate));

    if (isCookiesConsentExpired) {
      expiredCallback?.();
    }
  };

  useEffect(() => {
    checkCookiesExpirationDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const visibilityChangeHandler = () => {
    if (document.visibilityState !== 'visible') return;

    checkCookiesExpirationDate();
  };

  useEffect(() => {
    window.addEventListener('visibilitychange', visibilityChangeHandler);

    return () => {
      window.removeEventListener('visibilitychange', visibilityChangeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
